module.exports = __webpack_public_path__ + "img/shipping agent_wei.29e3e8b3.png";